import { CompanyDto } from 'dtos'

export function getComparableCompany({ companyGuid, name }: CompanyDto): CompanyDto {
  return {
    companyGuid,
    name
  }
}
